// extracted by mini-css-extract-plugin
export default {"page":"iZ-z","cartModal":"jZ-z","checkout":"kZ-z","placeholder":"lZ-z","account":"mZ-z"};